<template>
  <el-card class="ds-detail"
    style="position: relative; width: 100%">
    <div slot="header" class="clearfix">
      <el-button @click="$router.back()" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
      >&nbsp;
      <el-tag size="medium">{{ softwareName }}</el-tag>
    </div>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 发布更新程序
      </el-button>
      <div class="former">
        <el-input
          v-model="former['VerNumber:like']"
          placeholder="版本号"
          @keydown.enter.native="onSubmitQuery"
        ></el-input>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
      />
      <el-table-column prop="VerNumber" label="版本号"/>
      <el-table-column prop="Md5" label="MD5码"/>
      <el-table-column prop="Provider" width="150" label="上传者"/>
      <el-table-column prop="CreatedAt" width="150" label="上传时间">
        <template slot-scope="scope">
          <span v-if="scope.row.CreatedAt">
            {{scope.row.CreatedAt.substring(0, 10)}}</span>
        </template>
      </el-table-column>
      <el-table-column width="50" label="操作">
        <template slot-scope="scope">
          <el-link target="_blank" :href="scope.row.Url" :underline="false">
            <el-button
              type="primary"
              title="下载"
              :disabled="scope.row.Check === 1"
            >
            <i class="fas fa-download"></i>
          </el-button>
              </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>

    <item-form v-model="item" :visible.sync="itemVisible" :SoftwareId="itemSoftwareId" @form:saved="getItemList"/>
  </el-card>
</template>

<script>
import ItemForm from './index--form.vue';

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        'VerNumber:like': '',
        SoftwareID: this.$route.params.ID,
      },
      softwareName: this.$route.query.softwareName,
      item: this.getEmptyItem(),
      itemVisible: false,
      itemSoftwareId: this.$route.params.ID,
      typeList: {
        1: '文档', // 除了下面两种情况暂时都认为是文档
        2: '图片', // .jpg, .jpeg, .png, .gif
        3: '压缩包', // .zip, .rar
      },
      detailVisible: false,
      url: '',
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios.get('updateservice', {
        params: {
          where: this.former,
          ...this.pager,
        },
      }).then((response) => {
        this.itemList = response.data.data;
        this.pager = _.pick(response.data, 'size', 'page', 'total');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    getEmptyItem() {
      return {
        file: {},
        Type: 1,
        Remark: '',
        SoftwareId: this.$route.params.ID,
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm('确定要删除此文件吗？', '提示').then(
        () => this.$axios.delete(`ipc/file/${row.ID}`)
      ).then(() => {
        this.getItemList();
        this.$message.success('成功删除文件');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    onShowItem(row) {
      this.item = row;
      this.detailVisible = true;
    },
  },
};
</script>
